import useWindowPositionTop from 'hooks/useWindowPositionTop';
export default function CourseForChildren() {
    useWindowPositionTop();
  return (
    <>
      <style>{`
        .kids-basic-course {
          white-space: pre-line;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          margin: 0 auto;
          padding: 8rem 2rem;
          box-sizing: border-box;
          background: #fff;
          color: #222;
          border-radius: 8px;
          transition: padding 0.3s ease;
          max-width: 720px;
        }

        .kids-basic-course h2 {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #003366;
          line-height: 1.1;
        }

        .kids-basic-course p {
          margin-bottom: 1.25rem;
          font-size: 1.125rem;
          font-weight: 400;
          color: #333;
        }

        .kids-basic-course ul {
          margin-bottom: 1.75rem;
          padding-left: 1.5rem;
          list-style-type: disc;
          color: #444;
        }

        .kids-basic-course ul li {
          margin-bottom: 0.6rem;
          font-size: 1.05rem;
          line-height: 1.4;
        }

        .kids-basic-course strong {
          font-weight: 700;
          color: #002244;
        }

        .kids-basic-course .highlight {
          font-weight: 700;
          font-size: 1.2rem;
          color: #b22222;
          margin-top: 2rem;
        }

        /* Responsive typography and spacing */
        @media (max-width: 1024px) {
          .kids-basic-course h2 {
            font-size: 1.9rem;
          }
          .kids-basic-course p,
          .kids-basic-course ul li {
            font-size: 1rem;
          }
        }

        @media (max-width: 600px) {
          .kids-basic-course h2 {
            font-size: 1.6rem;
          }
          .kids-basic-course p,
          .kids-basic-course ul li {
            font-size: 0.95rem;
          }
          .kids-basic-course ul {
            padding-left: 1.2rem;
          }
        }

        @media (max-width: 360px) {
          .kids-basic-course h2 {
            font-size: 1.4rem;
          }
          .kids-basic-course p,
          .kids-basic-course ul li {
            font-size: 0.9rem;
          }
        }
      `}</style>

      <div className="kids-basic-course">
        <h2>Базовый курс для детей от 10 до 17 лет</h2>
        <p>
          Учил английский в школе, но так и не заговорил на нём? Вы сами удивитесь, как Ваш ребёнок начнёт говорить простыми предложениями уже после первых занятий.
        </p>
        <p><strong>🎯 УЧИМ АНГЛИЙСКИЙ С УДОВОЛЬСТВИЕМ!</strong></p>
        <p>
          Детский базовый курс английского для школьников 10-17 лет — это путь к свободному общению на языке возможностей!
        </p>

        <p><strong>Почему именно этот курс?</strong></p>
        <ul>
          <li>Увлекательная подача материала на примерах из фильмов и мультфильмов</li>
          <li>Игровые методики обучения</li>
          <li>Современные учебные материалы</li>
          <li>Индивидуальный подход к каждому ученику</li>
        </ul>

        <p><strong>🎯 Что получит ваш ребёнок:</strong></p>
        <ul>
          <li>Уверенное владение базовым словарным запасом</li>
          <li>Навыки чтения и письма</li>
          <li>Способность понимать английскую речь на слух</li>
          <li>Умение строить простые предложения с первых занятий</li>
          <li>Интерес к изучению языка</li>
        </ul>

        <p><strong>🏆 Преимущества курса:</strong></p>
        <ul>
          <li>Малые группы до 4 человек</li>
          <li>Интерактивные занятия</li>
          <li>Регулярный контроль прогресса</li>
          <li>Веселая атмосфера обучения</li>
        </ul>

        <p><strong>🎪 Чему научится Ваш ребёнок:</strong></p>
        <ul>
          <li>Грамматике — без скучных правил, через практику</li>
          <li>Словарному запасу — через игры и интересные темы</li>
          <li>Говорению — с первых занятий</li>
          <li>Чтению — от простых текстов к сложным</li>
          <li>Аутентичному произношению, близкому к звучанию носителей</li>
        </ul>

        <p><strong>🎁 Дополнительные бонусы:</strong></p>
        <ul>
          <li>Домашние задания с проверкой</li>
          <li>Доступ к онлайн-платформе</li>
          <li>Праздничные мероприятия на английском</li>
          <li>Языковые квесты, игры и конкурсы</li>
          <li>Сертификаты по окончании курса</li>
        </ul>

        <p><strong>👨‍👩‍👧 Для кого этот курс:</strong></p>
        <ul>
          <li>Для детей, начинающих с нуля</li>
          <li>Для школьников, желающих улучшить оценки</li>
          <li>Для подростков, планирующих сдавать экзамены</li>
          <li>Для всех, кто хочет говорить по-английски</li>
        </ul>

        <p><strong>⏰ Формат обучения:</strong></p>
        <ul>
          <li>Удобное расписание</li>
          <li>Онлайн занятия через Teams и Телемост</li>
          <li>Мини-группы по возрасту и уровню</li>
          <li>Продолжительность занятий 60-90 минут</li>
        </ul>

        <p><strong>💰 Специальное предложение:</strong></p>
        <ul>
          <li>Скидка 20% на первый месяц обучения</li>
          <li>Бесплатное пробное занятие</li>
          <li>Персональная консультация для родителей</li>
          <li>Подарок — набор учебных материалов</li>
        </ul>

        <p>
          Не упустите шанс дать своему ребёнку ключ к успеху в современном мире!
        </p>

        <p className="highlight">
          📞 ЗАПИШИТЕСЬ НА ПРОБНОЕ ЗАНЯТИЕ ПРЯМО СЕЙЧАС!<br />
          Количество мест в группах ограничено!<br />
          Ваш ребёнок заслуживает лучшего старта в изучении английского!
        </p>

        <p>#английскийдлядетей #обучениедетей #английскийязык #детскоенаселение #курсыанглийского</p>
      </div>
    </>
  );
}

